<template>
  <div class="l-main">
    <div class="l-main__ctn">
      <div class="c-table-wrapper">
        <base-table-component :prop-data="tableData" :use-id-as-key="true" is-ticket-banner>
          <template v-slot:action>
            <div class="header-table-section">
              Meta tags
            </div>
            <div class="add-button">
              <div>
                List of meta tags
              </div>
              <div class="add-section" @click="createOrUpdateScript()">
                <img src="../../../assets/add-button.svg" class="add-button__new" alt=""><span>Add new meta tag</span>
              </div>
            </div>
          </template>
          <template v-slot:default="slotProps">
            <div class="c-action-wrapper">
              <span class="c-table__btn-wrap c-toggle-wrap" :class="{ 'is-toggling': togglingIds[slotProps.selected.scriptItem.id] }">
                <md-switch
                  v-model="slotProps.selected.scriptItem.enabled"
                  style="max-width: 100px"
                  :disabled="!!togglingIds[slotProps.selected.scriptItem.id]"
                  @change="toggleScriptEnabled(slotProps.selected.scriptItem.id)"
                >
                  <span v-if="togglingIds[slotProps.selected.scriptItem.id]" class="c-toggle-saving">
                    <span class="c-toggle-spinner" />Saving&hellip;
                  </span>
                  <span v-else>{{ slotProps.selected.scriptItem.enabled ? 'Enabled' : 'Disabled' }}</span>
                </md-switch>
              </span>
              <span class="c-table__btn-wrap">
                <generic-button
                  icon
                  transparent
                  text-inherit
                  @click="createOrUpdateScript(slotProps.selected)"
                >
                  <md-tooltip md-direction="top"> Edit </md-tooltip>
                  <img src="../../../assets/edit-button.svg" alt="">
                </generic-button>
              </span>

              <span class="c-table__btn-wrap">
                <generic-button
                  icon
                  transparent
                  text-inherit
                  @click="openDeleteModal(slotProps.selected)"
                >
                  <md-tooltip md-direction="top"> Delete </md-tooltip>
                  <img src="../../../assets/delete-button.svg" alt="">
                </generic-button>
              </span>
            </div>
          </template>
        </base-table-component>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { isArray } from "lodash";
import GenericButton from "@/shared/buttons/GenericButton";
import DeleteModalComponent from "@/shared/delete-modal/DeleteModalComponent";
import MetaTagItemModal from "@/shared/form-fields/modals/meta-tag";
import BaseTableComponent from "@/shared/table/BaseTableComponent";
import { customScriptService } from "@/services/custom-script";

export default {
  name: "MetaTags",

  components: {
    GenericButton,
    BaseTableComponent,
  },

  props: {
    website: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      scriptItems: [],
      togglingIds: {},
    };
  },

  computed: {
    tableData() {
      return this.scriptItems.map(scriptItem => ({
        scriptItem,
        rowData: {
          name: scriptItem.name,
        },
        id: scriptItem.id,
      }));
    },
  },

  async created() {
    this.scriptItems = await this.loadScripts();
    this.getCustomPages();
  },

  methods: {
    ...mapActions("customPages", ["getCustomPages"]),
    ...mapActions("response", ["handleSuccess"]),

    async loadScripts() {
      try {
        const { data } = await customScriptService.getAll(this.website.id, "meta-tags");

        if (!isArray(data)) {
          return [];
        }

        return data;
      } catch (error) {
        return [];
      }
    },

    createOrUpdateScript(selected) {
      const scriptItem = selected && selected.scriptItem ? JSON.parse(JSON.stringify(selected.scriptItem)) : {
        id: null,
        name: "",
        script: "",
        enabled: true,
        location: "head",
        pageName: null,
        type: "meta-tags"
      };

        console.log(scriptItem)
      this.$modal.show(
        MetaTagItemModal,
        {
          scriptItem,
          successFunction: this.addOrUpdateScript,
        },
        { height: "auto", scrollable: true }
      );
    },

    openDeleteModal(selected) {
      this.$modal.show(
        DeleteModalComponent,
        {
          deleteMsg: selected.scriptItem.name,
          propData: selected.scriptItem.id,
          deleteFunction: this.deleteScript,
        },
        { height: "auto", scrollable: false, width: "440px" }
      );
    },

    addOrUpdateScript(scriptItem) {
      const isNew = scriptItem.id === null;

      if (isNew) {
        this.createScriptAPI(scriptItem)
          .then((createdScriptItem) => {
            this.scriptItems.push(createdScriptItem);
            this.handleSuccess({ message: "Script created successfully." });
          })
          .catch(() => {
            this.handleSuccess({ message: "Error saving script." });
          });
      } else {
        this.updateScriptAPI(scriptItem)
          .then((updatedScriptItem) => {
            const index = this.scriptItems.findIndex(item => item.id === scriptItem.id);
            if (index !== -1) {
              this.scriptItems.splice(index, 1, updatedScriptItem);
            }
            this.handleSuccess({ message: "Script updated successfully." });
          })
          .catch(() => {
            this.handleSuccess({ message: "Error saving script." });
          });
      }
    },

    minDelay(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    },

    toggleScriptEnabled(id) {
      const index = this.scriptItems.findIndex(item => item.id === id);
      if (index === -1) return;
      const scriptItem = this.scriptItems[index];
      const previousEnabled = !scriptItem.enabled;

      this.$set(this.togglingIds, id, true);

      Promise.all([this.updateScriptAPI(scriptItem), this.minDelay(400)])
        .then(() => {
          this.handleSuccess({ message: `Script ${scriptItem.enabled ? "enabled" : "disabled"} successfully.` });
        })
        .catch(() => {
          this.scriptItems[index].enabled = previousEnabled;
          this.handleSuccess({ message: "Error updating script." });
        })
        .finally(() => {
          this.$delete(this.togglingIds, id);
        });
    },

    deleteScript(id) {
      const index = this.scriptItems.findIndex(item => item.id === id);
      if (index === -1) return;
      const scriptItem = this.scriptItems[index];
      this.deleteScriptAPI(scriptItem)
        .then(() => {
          this.scriptItems.splice(index, 1);
          this.handleSuccess({ message: "Script deleted successfully." });
        })
        .catch(() => {
          this.handleSuccess({ message: "Error deleting script." });
        });
    },

    createScriptAPI(scriptItem) {
      const payload = {
        websiteId: this.website.id,
        name: scriptItem.name,
        script: scriptItem.script,
        enabled: scriptItem.enabled,
        location: "head",
        pageName: scriptItem.pageName,
        type: "meta-tags"
      };
      return customScriptService.create(payload).then(({ data }) => data);
    },

    updateScriptAPI(scriptItem) {
      const payload = {
        id: scriptItem.id,
        websiteId: this.website.id,
        name: scriptItem.name,
        script: scriptItem.script,
        enabled: scriptItem.enabled,
        location: "head",
        pageName: scriptItem.pageName,
        type: "meta-tags"
      };
      return customScriptService.update(payload).then(({ data }) => data);
    },

    deleteScriptAPI(scriptItem) {
      return customScriptService.delete(scriptItem.id);
    },
  },
}
</script>

<style lang="scss" scoped>
.c-action-wrapper {
  display: flex;
  align-items: center;
  padding-left: 10px;
}

.c-toggle-wrap {
  position: relative;

  &.is-toggling {
    opacity: 0.6;
    pointer-events: none;
  }
}

.c-toggle-saving {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-style: italic;
  color: inherit;
}

.c-toggle-spinner {
  display: inline-block;
  width: 10px;
  height: 10px;
  border: 2px solid currentColor;
  border-top-color: transparent;
  border-radius: 50%;
  animation: toggle-spin 0.6s linear infinite;
  flex-shrink: 0;
}

@keyframes toggle-spin {
  to { transform: rotate(360deg); }
}
</style>
